import { useQuery } from '@tanstack/react-query';

import * as ApiShowroom from '@Api/Showroom';
import { useRequest } from '@Contexts/Request';

import type { UseQueryResult } from '@tanstack/react-query';
import type { SellPointData } from '@Types/SellPoints';

function useSelectedSellPoint(id: number | string): UseQueryResult<SellPointData> {
  const { country, language } = useRequest();
  const keys = ['sell-point', { country, id, lang: language.id }];

  const result = useQuery({
    queryKey: keys,
    queryFn: async () => {
      if (!id) return null;
      return ApiShowroom.getSelectedSellPoint(id);
    },
    enabled: true,
    placeholderData: (previousData) => previousData,
  });

  return result;
}

export default useSelectedSellPoint;
